<template>
	<svg :class="direction_prop" :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M20 16L12 8L4 16" stroke="#007BFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
	</svg>

</template>

<script>
import { extractValueAndUnit } from '../../utils/iconUtils'

export default {

	name: 'IconArrow',

	props: {
		sizeMultiplier_prop: {
			type: Number,
			default: 1,
		},

		width_prop: {
			type: String,
			default: '1rem', // "px" or "em" only
		},

		height_prop: {
			type: String,
			default: '1rem', // "px" or "em" only
		},

		color_prop: {
			type: String,
			default: '',
		},

		direction_prop: {
			type: String,
			default: 'up',
		}
	},

	data() {
		return {
		}
	},

	computed: {
		color() {
			return this.color_prop || getComputedStyle(document.documentElement).getPropertyValue('--color-theme')
		},

		width() {
			const { value, unit } = extractValueAndUnit(this.width_prop)
			return `${value * this.sizeMultiplier_prop}${unit}`
		},

		height() {
			const { value, unit } = extractValueAndUnit(this.height_prop)
			return `${value * this.sizeMultiplier_prop}${unit}`
		},
	},
}
</script>

<style lang="css" scoped>
.right {
	transform: rotate(90deg); 
}

.down {
	transform: rotate(180deg); 
}

.left {
	transform: rotate(270deg); 
}

</style>